export const environment = {
    api: 'https://89cdcoz1ic.execute-api.eu-west-1.amazonaws.com', //! TEST
    websocket: 'wss://t3qpweeg40.execute-api.eu-west-1.amazonaws.com/test?access_token=',
    cognito: {
        userPoolId: 'eu-west-1_Gr5jo1ZGJ',
        userPoolClientId: '1bm1epir80gah230r52gig56sm'
    }
};
